export async function generateFile(annotatedImage) {
  return fetch(annotatedImage.url)
    .then(res => res.blob())
    .then(blob => {
      return new File([blob], annotatedImage.image_blob['filename'], { type: 'image/png' });
    });
}
